/**
 * Adds the minimal config that the input should provide
 * to the context.
 */
var BasicContextFeature = {
  name: 'core/basic-context',
  intercept: {
    request: {
      context: function context(_context, _ref) {
        var input = _ref.input;
        var url = input.url,
            method = input.method;
        _context.url = url;
        _context.method = method.toUpperCase();
        return _context;
      }
    }
  }
};

/**
 * Handles results the basic way.
 *
 * @returns Feature
 */
var BasicResultFeature = {
  name: 'core/result',
  handle: {
    request: {
      result: function result(_ref) {
        var error = _ref.error,
            response = _ref.response;

        if (error) {
          throw error;
        }

        return response;
      }
    }
  }
};

/**
 * Adds body data to context for applicable methods.
 */
var BodyFeature = {
  name: 'core/body',
  intercept: {
    request: {
      context: function context(_context, _ref) {
        var input = _ref.input;

        // Add body data.
        if (_context.method !== 'GET' && _context.method !== 'HEAD' && input != null && input.body) {
          var body = input.body;
          _context.body = body;
        }

        return _context;
      }
    }
  }
};

/**
 * Used in params & query feature.
 */
var Utils = /*#__PURE__*/function () {
  function Utils() {}

  /**
   * Encodes string for usage in URL.
   *
   * @param val
   * @returns
   */
  Utils.encode = function encode(val) {
    if (this.isDate(val)) {
      val = val;
      val = val.toISOString();
    } else if (this.isObject(val)) {
      val = JSON.stringify(val);
    }

    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
  }
  /**
   * Checks if date.
   *
   * @param val
   * @returns
   */
  ;

  Utils.isDate = function isDate(val) {
    return toString.call(val) === '[object Date]';
  }
  /**
   * Checks if object.
   *
   * @param val
   * @returns
   */
  ;

  Utils.isObject = function isObject(val) {
    return val !== null && typeof val === 'object';
  };

  return Utils;
}();

/**
 * Overwrites placeholders in context URL with provided params.
 */

var ParamsFeature = {
  name: 'core/params',
  intercept: {
    request: {
      context: function context(_context, _ref) {
        var input = _ref.input;
        var url = _context.url;
        _context.pseudoUrl = url;
        var params = (input == null ? void 0 : input.params) || {};

        for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _Object$entries[_i],
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];
          url = url.replace(new RegExp(':' + key, 'gi'), Utils.encode(value));
        }

        _context.url = url;
        return _context;
      }
    }
  }
};

/**
 * Adds encoded query items to context URL.
 */

var QueryFeature = function QueryFeature() {
  return {
    name: 'core/query',
    intercept: {
      request: {
        context: function context(_context, _ref) {
          var input = _ref.input;

          if (input != null && input.query) {
            (function () {
              var query = input.query;
              _context.query = query;
              var url = _context.url; // Build params string.

              var queryItems = [];
              var queryEntries = Object.entries(query);

              var _loop = function _loop() {
                var _queryEntries$_i = _queryEntries[_i],
                    key = _queryEntries$_i[0],
                    value = _queryEntries$_i[1];

                if (Array.isArray(value)) {
                  key = key + '[]';
                } else {
                  value = [value];
                }

                value.map(function (v) {
                  if (typeof v !== 'undefined' && v !== null) {
                    queryItems.push(Utils.encode(key) + '=' + Utils.encode(v));
                  }
                });
              };

              for (var _i = 0, _queryEntries = queryEntries; _i < _queryEntries.length; _i++) {
                _loop();
              }

              if (queryItems.length) {
                var glue = url.indexOf('?') > -1 ? '&' : '?';
                url = url + glue + queryItems.join('&');
                _context.url = url;
              }
            })();
          }

          return _context;
        }
      }
    }
  };
};

/**
 * Prepends a base URL to the context URL.
 *
 * @returns Feature
 */
var BaseUrlFeature = function BaseUrlFeature() {
  var defaults = {
    baseUrl: false
  };
  return {
    name: 'core/base-url',
    set: function set(args) {
      if (typeof (args == null ? void 0 : args.baseUrl) !== 'undefined') {
        defaults.baseUrl = args.baseUrl;
      }
    },
    intercept: {
      request: {
        context: function context(_context, _ref) {
          var input = _ref.input;
          var baseUrl = (input == null ? void 0 : input.baseUrl) === false ? false : input != null && input.baseUrl ? input == null ? void 0 : input.baseUrl : defaults.baseUrl;
          _context.baseUrl = baseUrl;

          if (baseUrl) {
            _context.url = baseUrl + _context.url;
          }

          return _context;
        }
      }
    }
  };
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/**
 * Adds headers to the context.
 *
 * @returns Feature
 */
var HeadersFeature = function HeadersFeature() {
  var defaults = {
    headers: {}
  };
  return {
    name: 'core/headers',
    set: function set(args) {
      if (typeof (args == null ? void 0 : args.headers) === 'function') {
        defaults.headers = args.headers(defaults.headers);
      }
    },
    intercept: {
      request: {
        context: function context(_context, _ref) {
          var input = _ref.input;

          if (typeof (input == null ? void 0 : input.headers) === 'function') {
            _context.headers = input.headers(_extends({}, defaults.headers));
          } else {
            _context.headers = _extends({}, defaults.headers);
          }

          return _context;
        }
      }
    }
  };
};

/**
 * Adds optional payload to context.
 */
var PayloadFeature = {
  name: 'core/payload',
  intercept: {
    request: {
      context: function context(_context, _ref) {
        var input = _ref.input;

        if (input != null && input.payload) {
          _context.payload = input.payload;
        }

        return _context;
      }
    }
  }
};

/**
 * Adds a Content-Type to context headers based on config or on body data when on 'auto' mode.
 *
 * @returns Feature
 */
var ContentTypeFeature = function ContentTypeFeature() {
  var defaults = {
    contentType: 'auto'
  };
  return {
    name: 'core/content-type',
    set: function set(args) {
      if (args != null && args.contentType) {
        defaults.contentType = args.contentType;
      }
    },
    intercept: {
      request: {
        context: function context(_context, _ref) {
          var input = _ref.input;
          var contentTypeValue;
          var contentType = (input == null ? void 0 : input.contentType) || defaults.contentType;

          if (!contentType) {
            return _context;
          }

          if (contentType !== 'auto') {
            contentTypeValue = contentType;
          } else {
            // Find content type based on provided data.
            var body = _context.body;

            if (body) {
              if (typeof FormData !== 'undefined' && body instanceof FormData) {
                contentTypeValue = 'multipart/form-data';
              } else if (typeof body === 'object') {
                contentTypeValue = 'application/json';
              }
            }
          }

          if (contentTypeValue) {
            if (!_context.headers) {
              _context.headers = {};
            }

            _context.headers['Content-Type'] = contentTypeValue;
          }

          return _context;
        }
      }
    }
  };
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

/**
 * List of possible Apiator error types.
 */
var ExceptionType;

(function (ExceptionType) {
  ExceptionType["HTTP_ERROR"] = "HTTP_ERROR";
  ExceptionType["SCRIPT_ERROR"] = "SCRIPT_ERROR";
  ExceptionType["ABORT_ERROR"] = "ABORT_ERROR";
  ExceptionType["NETWORK_ERROR"] = "NETWORK_ERROR";
  ExceptionType["TIMEOUT_ERROR"] = "TIMEOUT_ERROR";
})(ExceptionType || (ExceptionType = {}));

var Exception = /*#__PURE__*/function (_Error) {
  _inheritsLoose(Exception, _Error);

  function Exception(type, message, extend) {
    var _this$is;

    var _this;

    _this = _Error.call(this, message) || this;
    _this.name = 'ApiatorError';
    _this.type = type;
    _this.is = (_this$is = {}, _this$is[type] = true, _this$is); // Extend error data

    if (extend) {
      for (var _i = 0, _Object$entries = Object.entries(extend); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _Object$entries[_i],
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
        _this[key] = value;
      }
    }

    return _this;
  }

  return Exception;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var HttpException = /*#__PURE__*/function (_Exception) {
  _inheritsLoose(HttpException, _Exception);

  function HttpException(message, data) {
    return _Exception.call(this, ExceptionType.HTTP_ERROR, message, data) || this;
  }

  return HttpException;
}(Exception);

var ScriptException = /*#__PURE__*/function (_Exception) {
  _inheritsLoose(ScriptException, _Exception);

  function ScriptException(message, data) {
    return _Exception.call(this, ExceptionType.SCRIPT_ERROR, message, data) || this;
  }

  return ScriptException;
}(Exception);

var AbortException = /*#__PURE__*/function (_Exception) {
  _inheritsLoose(AbortException, _Exception);

  function AbortException(message, data) {
    return _Exception.call(this, ExceptionType.ABORT_ERROR, message, data) || this;
  }

  return AbortException;
}(Exception);

var NetworkException = /*#__PURE__*/function (_Exception) {
  _inheritsLoose(NetworkException, _Exception);

  function NetworkException(message, data) {
    return _Exception.call(this, ExceptionType.NETWORK_ERROR, message, data) || this;
  }

  return NetworkException;
}(Exception);

/**
 * Sends and aborts requests using Fetch API.
 *
 * @return Feature
 */

var FetchApiFeature = function FetchApiFeature() {
  var data = {
    fetch: undefined
  };
  return {
    name: 'core/fetch-api',
    set: function set(args) {
      if (args != null && args.fetch) {
        data.fetch = args.fetch;
      }
    },
    handle: {
      request: {
        send: function () {
          var _send = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
            var context, options, body, response, errorResponse, message, errorData;
            return runtime_1.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;

                    if (!(typeof fetch === 'undefined' && !data.fetch)) {
                      _context.next = 3;
                      break;
                    }

                    throw new ScriptException('Fetch API feature requires a valid `fetch` function. You can pass it via the `fetch` argument.');

                  case 3:
                    _context.next = 5;
                    return request.getContext();

                  case 5:
                    context = _context.sent;

                    if (!(!context.url || !context.method)) {
                      _context.next = 8;
                      break;
                    }

                    throw new ScriptException('Fetch API feature requires at least `url` and `method` to be defined in context.');

                  case 8:
                    // Build fetch options.
                    options = _extends({
                      signal: context._abortSignal,
                      method: context.method,
                      headers: context.headers
                    }, context.opts || {}); // Check for body. Stringify if necessary.

                    if (context.body) {
                      body = context.body;

                      if (typeof body === 'object') {
                        body = JSON.stringify(body);
                      } else {
                        body = body;
                      }

                      options.body = body;
                    } // Fetch.


                    if (!data.fetch) {
                      _context.next = 16;
                      break;
                    }

                    _context.next = 13;
                    return data.fetch(context.url, options);

                  case 13:
                    response = _context.sent;
                    _context.next = 19;
                    break;

                  case 16:
                    _context.next = 18;
                    return fetch(context.url, options);

                  case 18:
                    response = _context.sent;

                  case 19:
                    if (response.ok) {
                      _context.next = 25;
                      break;
                    }

                    errorResponse = response.clone();
                    _context.next = 23;
                    return errorResponse.text();

                  case 23:
                    message = _context.sent;
                    throw new HttpException(message, {
                      request: request,
                      response: response
                    });

                  case 25:
                    return _context.abrupt("return", response);

                  case 28:
                    _context.prev = 28;
                    _context.t0 = _context["catch"](0);
                    // Catch any non-HTTP error.
                    errorData = {
                      request: request
                    }; // Check if we have an abort error.
                    // This is the name set by Fetch API.

                    if (!(_context.t0.name === 'AbortError')) {
                      _context.next = 35;
                      break;
                    }

                    throw new AbortException('Request aborted by user.', errorData);

                  case 35:
                    if (!(_context.t0.message === 'Network request failed' || // E.g. when no connection.
                    _context.t0.message === 'TypeError: NetworkError when attempting to fetch resource.' // E.g. when CORS error.
                    )) {
                      _context.next = 39;
                      break;
                    }

                    throw new NetworkException(_context.t0.message, errorData);

                  case 39:
                    if (!(_context.t0.name === 'ApiatorError')) {
                      _context.next = 43;
                      break;
                    }

                    throw _context.t0;

                  case 43:
                    throw new ScriptException(_context.t0);

                  case 44:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 28]]);
          }));

          function send(_x) {
            return _send.apply(this, arguments);
          }

          return send;
        }()
      }
    }
  };
};

/**
 * Formats the response body before returning the result.
 *
 * @returns Feature
 */

var FetchApiFormatFeature = function FetchApiFormatFeature() {
  var defaults = {
    format: 'auto'
  };
  return {
    name: 'core/fetch-api-format',
    set: function set(args) {
      if (args != null && args.format) {
        defaults.format = args.format;
      }
    },
    intercept: {
      request: {
        context: function context(_context, _ref) {
          var input = _ref.input;
          var format = input == null ? void 0 : input.format;
          _context.format = format === false ? false : format || defaults.format;
          return _context;
        },
        response: function () {
          var _response2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_response, _ref2) {
            var request, context, format, contentType, matchers, _i, _Object$entries, _Object$entries$_i, matcher, formatMethod, found, formatted;

            return runtime_1.wrap(function _callee$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    request = _ref2.request;
                    _context2.next = 3;
                    return request.getContext();

                  case 3:
                    context = _context2.sent;
                    format = context.format;

                    if (!(format === 'auto')) {
                      _context2.next = 22;
                      break;
                    }

                    format = false; // Try to find the right format based on response headers.

                    contentType = _response.headers.get('Content-Type');

                    if (!contentType) {
                      _context2.next = 20;
                      break;
                    }

                    matchers = {
                      'application/json': 'json',
                      'multipart/form-data': 'formData',
                      'text/|application/javascript|application/ecmascript': 'text',
                      'font/|image/|video/|audio/|application/|model/': 'blob'
                    };
                    _i = 0, _Object$entries = Object.entries(matchers);

                  case 11:
                    if (!(_i < _Object$entries.length)) {
                      _context2.next = 20;
                      break;
                    }

                    _Object$entries$_i = _Object$entries[_i], matcher = _Object$entries$_i[0], formatMethod = _Object$entries$_i[1];
                    found = contentType.match(new RegExp(matcher, 'gi'));

                    if (!(found != null && found.length)) {
                      _context2.next = 17;
                      break;
                    }

                    format = formatMethod;
                    return _context2.abrupt("break", 20);

                  case 17:
                    _i++;
                    _context2.next = 11;
                    break;

                  case 20:
                    if (format) {
                      _context2.next = 22;
                      break;
                    }

                    throw new ScriptException("Cannot auto format server response. Did the server send a 'Content-Type' header? If you cannot fix it server-side you should NOT use the 'auto' option. Set the format manually instead.", {
                      response: _response,
                      request: request
                    });

                  case 22:
                    if (!format) {
                      _context2.next = 39;
                      break;
                    }

                    if (!_response[format]) {
                      _context2.next = 36;
                      break;
                    }

                    _context2.prev = 24;
                    _context2.next = 27;
                    return _response[format]();

                  case 27:
                    formatted = _context2.sent;
                    return _context2.abrupt("return", formatted);

                  case 31:
                    _context2.prev = 31;
                    _context2.t0 = _context2["catch"](24);
                    throw new ScriptException("Cannot format output to '" + format + "'. Did the server send the right content type?", {
                      response: _response,
                      request: request
                    });

                  case 34:
                    _context2.next = 37;
                    break;

                  case 36:
                    throw new ScriptException("Cannot find provided `format` method '" + format + "' on response object. Typo?", {
                      response: _response,
                      request: request
                    });

                  case 37:
                    _context2.next = 40;
                    break;

                  case 39:
                    return _context2.abrupt("return", _response);

                  case 40:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee, null, [[24, 31]]);
          }));

          function response(_x, _x2) {
            return _response2.apply(this, arguments);
          }

          return response;
        }()
      }
    }
  };
};

/**
 * Adds abort method to request(s) and _abortSignal to context.
 *
 * @return Feature
 */

var FetchApiAbortFeature = function FetchApiAbortFeature() {
  var defaults = {
    fetchAbortController: undefined
  };
  return {
    name: 'core/fetch-api-abort',
    set: function set(args) {
      if (args != null && args.fetchAbortController) {
        defaults.fetchAbortController = args.fetchAbortController;
      }
    },
    extend: function extend(instance) {
      instance.Request.prototype.abort = /*#__PURE__*/function () {
        var _abort = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
          var context, controller;
          return runtime_1.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.getContext();

                case 2:
                  context = _context.sent;
                  controller = context._abortController;

                  if (controller) {
                    controller.abort();
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function abort() {
          return _abort.apply(this, arguments);
        }

        return abort;
      }();

      instance.Requests.prototype.abort = /*#__PURE__*/function () {
        var _abort2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
          return runtime_1.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  this.list.map(function (request) {
                    if (typeof request.abort === 'function') {
                      request.abort();
                    }
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function abort() {
          return _abort2.apply(this, arguments);
        }

        return abort;
      }();
    },
    clear: function clear(instance) {
      instance.Request.prototype.abort = undefined;
      instance.Requests.prototype.abort = undefined;
    },
    intercept: {
      request: {
        context: function context(_context3) {
          // Prepare abort feature.
          var controller;

          try {
            var _window;

            if (defaults.fetchAbortController) {
              controller = new defaults.fetchAbortController();
            } else if ((_window = window) != null && _window.AbortController) {
              controller = new window.AbortController();
            } else {
              controller = new AbortController();
            }
          } catch (err) {
            throw new ScriptException('FetchAPI Abort Feature: Cannot create AbortController instance. Is your environment supporting the AbortController?' + 'Try to use a polyfill or set a reference via `api.set({ fetchAbortController: Reference })`.' + 'If you do not need to abort you can also disable it via `api.discard(FetchApiAbortFeature)`.' + 'More info: https://developer.mozilla.org/en-US/docs/Web/API/AbortController');
          }

          var _controller = controller,
              signal = _controller.signal;
          _context3._abortController = controller;
          _context3._abortSignal = signal;
          return _context3;
        }
      }
    }
  };
};

/**
 * Transforms responses and errors into a [error, response] duplet.
 *
 * @returns Feature
 */
var DupletFeature = function DupletFeature() {
  var defaults = {
    duplet: true
  };
  return {
    name: 'core/duplet',
    set: function set(args) {
      if (args != null && args.duplet) {
        defaults.duplet = args.duplet;
      }
    },
    handle: {
      request: {
        result: function result(_ref, _ref2) {
          var error = _ref.error,
              response = _ref.response;
          var context = _ref2.context;

          if (context != null && context.duplet) {
            if (error) {
              return [error, undefined];
            }

            if (typeof response !== 'undefined') {
              return [undefined, response];
            }

            return [undefined, null];
          }

          if (error) {
            throw error;
          }

          return response;
        }
      }
    },
    intercept: {
      request: {
        context: function context(_context, _ref3) {
          var input = _ref3.input;
          _context.duplet = (input == null ? void 0 : input.duplet) || defaults.duplet;
          return _context;
        }
      }
    }
  };
};

/**
 * Automatically logs infos and warnings to console.
 *
 * @returns Feature
 */
var DebugFeature = function DebugFeature() {
  var defaults = {
    debug: false
  };

  var logger = function logger(type, context, title, contentName, content) {
    var _console;

    if (type === void 0) {
      type = 'log';
    }

    var color = type === 'error' ? 'Crimson' : 'DeepSkyBlue';

    (_console = console).log.apply(_console, ["%c[ " + title + " ] %c" + context.method, "color:" + color + "; font-weight: bold;", "font-weight: bold;", context.url + "\n\n" + contentName + " =", content]);
  };

  return {
    name: 'core/debug',
    set: function set(args) {
      if (args != null && args.debug) {
        defaults.debug = args == null ? void 0 : args.debug;
      }
    },
    intercept: {
      request: {
        context: function context(_context, _ref) {
          var input = _ref.input;
          var enabled = (input == null ? void 0 : input.debug) || defaults.debug;
          _context.debug = enabled;
          return _context;
        }
      }
    },
    on: {
      send: function () {
        var _send = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref2) {
          var request, context;
          return runtime_1.wrap(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  request = _ref2.request;
                  _context2.next = 3;
                  return request.getContext();

                case 3:
                  context = _context2.sent;

                  if (context.debug) {
                    _context2.next = 6;
                    break;
                  }

                  return _context2.abrupt("return");

                case 6:
                  logger('log', context, 'REQUEST_SENT', 'context', context);

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee);
        }));

        function send(_x) {
          return _send.apply(this, arguments);
        }

        return send;
      }(),
      result: function () {
        var _result = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(_ref3) {
          var error, request, context;
          return runtime_1.wrap(function _callee2$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  error = _ref3.error, request = _ref3.request;
                  _context3.next = 3;
                  return request.getContext();

                case 3:
                  context = _context3.sent;

                  if (context.debug) {
                    _context3.next = 6;
                    break;
                  }

                  return _context3.abrupt("return");

                case 6:
                  if (error) {
                    delete error.request;
                    logger('error', context, error.type || 'ERROR', 'error', error);
                  } // DISABLED. Let's not show anything on success, since we devs can
                  // see that result in their network tools.
                  // if (response) {
                  // console.log(
                  //   ...content(context, 'RESPONSE_SUCCESS', 'context', context)
                  // );
                  // }


                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee2);
        }));

        function result(_x2) {
          return _result.apply(this, arguments);
        }

        return result;
      }()
    }
  };
};

/**
 * Adds additional options to the context.
 *
 * @returns Feature
 */
var OptsFeature = function OptsFeature() {
  var defaults = {
    opts: {}
  };
  return {
    name: 'core/opts',
    set: function set(args) {
      if (typeof (args == null ? void 0 : args.opts) === 'function') {
        defaults.opts = args.opts(defaults.opts);
      }
    },
    intercept: {
      request: {
        context: function context(_context, _ref) {
          var input = _ref.input;

          if (typeof (input == null ? void 0 : input.opts) === 'function') {
            _context.opts = input.opts(_extends({}, defaults.opts));
          } else {
            _context.opts = _extends({}, defaults.opts);
          }

          return _context;
        }
      }
    }
  };
};

/**
 * Returned by request() method.
 */
var Request = /*#__PURE__*/function () {
  function Request(instance, input) {
    this._input = null;
    this._context = null;
    this.instance = instance;
    this.input = input;
  }
  /**
   * Applies result handle and listener and returns result.
   *
   * @param error
   * @returns
   */


  var _proto = Request.prototype;

  _proto._handleError =
  /*#__PURE__*/
  function () {
    var _handleError2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(error) {
      var context, input, result;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getContext();

            case 2:
              context = _context.sent;
              _context.next = 5;
              return this.getInput();

            case 5:
              input = _context.sent;
              result = this.instance.handle('request', 'result', {
                error: error
              }, {
                request: this,
                context: context,
                input: input
              });
              this.instance.emit('result', {
                error: error,
                request: this
              });
              return _context.abrupt("return", result);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function _handleError(_x) {
      return _handleError2.apply(this, arguments);
    }

    return _handleError;
  }()
  /**
   * Applies inteceptors and returns request input.
   *
   * @returns
   */
  ;

  _proto.getInput =
  /*#__PURE__*/
  function () {
    var _getInput = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
      var interceptedInput;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!this._input) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", this._input);

            case 2:
              _context2.next = 4;
              return this.instance.intercept('request', 'input', this.input);

            case 4:
              interceptedInput = _context2.sent;
              this._input = interceptedInput;
              return _context2.abrupt("return", interceptedInput);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getInput() {
      return _getInput.apply(this, arguments);
    }

    return getInput;
  }()
  /**
   * Applies inteceptors and returns request context.
   *
   * @returns
   */
  ;

  _proto.getContext =
  /*#__PURE__*/
  function () {
    var _getContext = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
      var input, context;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!this._context) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", this._context);

            case 2:
              _context3.next = 4;
              return this.getInput();

            case 4:
              input = _context3.sent;
              _context3.next = 7;
              return this.instance.intercept('request', 'context', {}, {
                input: input
              });

            case 7:
              context = _context3.sent;
              this._context = context;
              return _context3.abrupt("return", context);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getContext() {
      return _getContext.apply(this, arguments);
    }

    return getContext;
  }()
  /**
   * Sends the request and handles the response.
   *
   * @returns
   */
  ;

  _proto.send =
  /*#__PURE__*/
  function () {
    var _send = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4() {
      var input, context, response, result, _result;

      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.getInput();

            case 3:
              input = _context4.sent;
              _context4.next = 6;
              return this.getContext();

            case 6:
              context = _context4.sent;
              this.instance.emit('send', {
                request: this
              });
              _context4.next = 10;
              return this.instance.handle('request', 'send', this, {
                context: context,
                input: input
              });

            case 10:
              response = _context4.sent;
              _context4.next = 13;
              return this.instance.intercept('request', 'response', response, {
                context: context,
                input: input,
                request: this
              });

            case 13:
              response = _context4.sent;
              result = this.instance.handle('request', 'result', {
                response: response
              }, {
                context: context,
                input: input,
                request: this
              });
              this.instance.emit('result', {
                request: this,
                response: response
              });
              return _context4.abrupt("return", result);

            case 19:
              _context4.prev = 19;
              _context4.t0 = _context4["catch"](0);
              _context4.prev = 21;
              _context4.next = 24;
              return this._handleError(_context4.t0);

            case 24:
              _result = _context4.sent;
              return _context4.abrupt("return", _result);

            case 28:
              _context4.prev = 28;
              _context4.t1 = _context4["catch"](21);
              throw _context4.t1;

            case 31:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 19], [21, 28]]);
    }));

    function send() {
      return _send.apply(this, arguments);
    }

    return send;
  }();

  return Request;
}();

/**
 * Returned by requests() method.
 */
var Requests = /*#__PURE__*/function () {
  function Requests(instance, list) {
    this.list = [];
    this.instance = instance;
    this.list = list;
  }
  /**
   * Sends all requests.
   *
   * @returns
   */


  var _proto = Requests.prototype;

  _proto.send =
  /*#__PURE__*/
  function () {
    var _send = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      var promises, promiseResults, errors, responses;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              promises = [];
              this.list.map(function (request) {
                promises.push(request.send());
              });
              _context.next = 4;
              return Promise.all(promises);

            case 4:
              promiseResults = _context.sent;
              errors = [];
              responses = [];
              promiseResults.map(function (result) {
                var err = result[0],
                    response = result[1];
                responses.push(response);

                if (err) {
                  errors.push(err);
                }
              });

              if (!(errors.length === 0)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", [undefined, responses]);

            case 10:
              return _context.abrupt("return", [errors, responses]);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function send() {
      return _send.apply(this, arguments);
    }

    return send;
  }();

  return Requests;
}();

/**
 * Returned by createInstance().
 */

var Apiator = /*#__PURE__*/function () {
  /**
   * Sets features and default args on construction.
   *
   * @param args
   */
  function Apiator(features, args) {
    if (args === void 0) {
      args = {};
    }

    /**
     * List of queues that define in which and in what
     * order features can manipulate.
     */
    this._queues = {
      handle: {},
      intercept: {}
    };
    /**
     * Contains the list of features at use.
     */

    this._features = {};
    /**
     * Contains list of registered event listener.
     */

    this._listeners = {
      send: [],
      result: []
    }; // Create copy of relevant classes and attach to instance.
    // This will allow instance specific protyping in features.
    // TODO: this does not feel ideal.

    this.Request = /*#__PURE__*/function (_Request) {
      _inheritsLoose(_class, _Request);

      function _class(instance, input) {
        return _Request.call(this, instance, input) || this;
      }

      return _class;
    }(Request);

    this.Requests = /*#__PURE__*/function (_Requests) {
      _inheritsLoose(_class2, _Requests);

      function _class2(instance, input) {
        return _Requests.call(this, instance, input) || this;
      }

      return _class2;
    }(Requests);

    this.use(features);
    this.set(args);
  }
  /**
   * Creates a feature.
   *
   * @param Feature
   * @returns
   */


  var _proto = Apiator.prototype;

  _proto._createFeature = function _createFeature(Feature) {
    var feature;

    if (typeof Feature === 'function') {
      feature = new Feature();
    } else {
      feature = Feature;
    }

    if (!feature) {
      throw new ScriptException("Feature '" + JSON.stringify(feature).substr(0, 40) + "'... is not a valid feature.");
    }

    if (!feature.name) {
      throw new ScriptException("Feature '" + JSON.stringify(feature).substr(0, 40) + "'... needs a name.");
    }

    return feature;
  }
  /**
   * Finds/build relavant queues for feature and makes them accessible in a loop.
   *
   * @param feature
   * @param callback
   */
  ;

  _proto._forEachQueueOfFeature = function _forEachQueueOfFeature(feature, callback) {
    for (var _i = 0, _Object$entries = Object.entries(this._queues); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
          action = _Object$entries$_i[0];
      if (!feature[action]) continue;

      for (var _i2 = 0, _Object$entries2 = Object.entries(feature[action]); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _Object$entries2[_i2],
            target = _Object$entries2$_i[0];

        if (!this._queues[action][target]) {
          this._queues[action][target] = {};
        }

        for (var _i3 = 0, _Object$entries3 = Object.entries(feature[action][target]); _i3 < _Object$entries3.length; _i3++) {
          var _Object$entries3$_i = _Object$entries3[_i3],
              name = _Object$entries3$_i[0];

          if (!this._queues[action][target][name]) {
            this._queues[action][target][name] = [];
          }

          var queue = this._queues[action][target][name];
          callback(queue);
        }
      }
    }
  }
  /**
   * Passes a config update to all features.
   *
   * @param args
   */
  ;

  _proto.set = function set(args) {
    for (var _i4 = 0, _Object$entries4 = Object.entries(this._features); _i4 < _Object$entries4.length; _i4++) {
      var _Object$entries4$_i = _Object$entries4[_i4],
          feature = _Object$entries4$_i[1];

      if (feature != null && feature.set && typeof feature.set === 'function') {
        feature.set(args);
      }
    }
  }
  /**
   * Applies interceptor for a given stage.
   *
   * @param stage
   * @param current
   * @param context
   * @returns
   */
  ;

  _proto.intercept =
  /*#__PURE__*/
  function () {
    var _intercept = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(target, name, current, extra) {
      var _this$_queues, _this$_queues$interce, _this$_queues$interce2;

      var queue, featureName, interceptor, i, _this$_features$featu, _this$_features$featu2, _this$_features$featu3;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (extra === void 0) {
                extra = {};
              }

              queue = (_this$_queues = this._queues) == null ? void 0 : (_this$_queues$interce = _this$_queues.intercept) == null ? void 0 : (_this$_queues$interce2 = _this$_queues$interce[target]) == null ? void 0 : _this$_queues$interce2[name];

              if (!queue) {
                _context.next = 14;
                break;
              }

              i = 0;

            case 4:
              if (!(i < queue.length)) {
                _context.next = 14;
                break;
              }

              featureName = queue[i];
              interceptor = (_this$_features$featu = this._features[featureName]) == null ? void 0 : (_this$_features$featu2 = _this$_features$featu.intercept) == null ? void 0 : (_this$_features$featu3 = _this$_features$featu2[target]) == null ? void 0 : _this$_features$featu3[name];

              if (!(typeof interceptor === 'function')) {
                _context.next = 11;
                break;
              }

              _context.next = 10;
              return interceptor(current, extra);

            case 10:
              current = _context.sent;

            case 11:
              i++;
              _context.next = 4;
              break;

            case 14:
              return _context.abrupt("return", current);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function intercept(_x, _x2, _x3, _x4) {
      return _intercept.apply(this, arguments);
    }

    return intercept;
  }()
  /**
   * Handles by choosen feature.
   *
   * @param property
   * @param contract
   * @param context
   * @returns
   */
  ;

  _proto.handle = function handle(target, name, contract, extra) {
    var _this$_queues2, _this$_queues2$handle, _this$_queues2$handle2;

    var queue = (_this$_queues2 = this._queues) == null ? void 0 : (_this$_queues2$handle = _this$_queues2.handle) == null ? void 0 : (_this$_queues2$handle2 = _this$_queues2$handle[target]) == null ? void 0 : _this$_queues2$handle2[name];

    if (queue) {
      var _this$_features$handl, _this$_features$handl2, _this$_features$handl3;

      var handlingFeatureName = queue[queue.length - 1];
      var handler = (_this$_features$handl = this._features[handlingFeatureName]) == null ? void 0 : (_this$_features$handl2 = _this$_features$handl.handle) == null ? void 0 : (_this$_features$handl3 = _this$_features$handl2[target]) == null ? void 0 : _this$_features$handl3[name];

      if (typeof handler === 'function') {
        return handler(contract, extra);
      }
    }

    return contract;
  }
  /**
   * Adds one or more features.
   *
   * @param feature
   */
  ;

  _proto.use = function use(oneOrManyFeatures) {
    var _this = this;

    var useFeature = function useFeature(Feature) {
      var feature = _this._createFeature(Feature); // Check.


      if (_this._features[feature.name]) {
        throw new ScriptException("Feature with name '" + feature.name + "' is already in use.");
      } // Check if feature has queueable properties and add them.


      _this._forEachQueueOfFeature(feature, function (queue) {
        queue.push(feature.name);
      }); // Extend instance


      if (feature.extend) {
        feature.extend(_this);
      } // Register events.


      if (feature.on) {
        for (var _i5 = 0, _Object$entries5 = Object.entries(feature.on); _i5 < _Object$entries5.length; _i5++) {
          var _Object$entries5$_i = _Object$entries5[_i5],
              eventName = _Object$entries5$_i[0],
              listener = _Object$entries5$_i[1];

          _this.on(eventName, listener);
        }
      }

      _this._features[feature.name] = feature;
    };

    if (Array.isArray(oneOrManyFeatures)) {
      oneOrManyFeatures.map(function (Feature) {
        return useFeature(Feature);
      });
    } else {
      useFeature(oneOrManyFeatures);
    }
  }
  /**
   * Discards one or more features.
   *
   * @param featureName
   */
  ;

  _proto.discard = function discard(oneOrManyFeatures) {
    var _this2 = this;

    var discardFeature = function discardFeature(Feature) {
      var feature = _this2._createFeature(Feature); // Remove all interceptors and handlers from queue.


      _this2._forEachQueueOfFeature(feature, function (queue) {
        var index = queue.indexOf(feature.name);

        if (index > -1) {
          queue.splice(index, 1);
        }
      }); // Clear instance


      if (feature.clear) {
        feature.extend(_this2);
      } // Remove event listeners.


      if (feature.on) {
        for (var _i6 = 0, _Object$entries6 = Object.entries(feature.on); _i6 < _Object$entries6.length; _i6++) {
          var _Object$entries6$_i = _Object$entries6[_i6],
              eventName = _Object$entries6$_i[0],
              listener = _Object$entries6$_i[1];

          _this2.off(eventName, listener);
        }
      }

      delete _this2._features[feature.name];
    };

    if (Array.isArray(oneOrManyFeatures)) {
      oneOrManyFeatures.map(function (feature) {
        return discardFeature(feature);
      });
    } else {
      discardFeature(oneOrManyFeatures);
    }
  }
  /**
   * Registers an event listener.
   *
   * @param eventName
   * @param listener
   */
  ;

  _proto.on = function on(eventName, listener) {
    var _this$_listeners;

    if ((_this$_listeners = this._listeners) != null && _this$_listeners[eventName] && typeof listener === 'function') {
      this._listeners[eventName].push(listener);
    }
  }
  /**
   * Removes an event listener.
   *
   * @param eventName
   * @param listener
   */
  ;

  _proto.off = function off(eventName, listener) {
    var listeners = this._listeners[eventName];

    if (listeners) {
      var index = listeners.indexOf(listener);

      if (index > -1) {
        listeners.splice(index, 1);
      }
    }
  }
  /**
   * Emits an event.
   *
   * @param {*} event
   * @param {*} context
   */
  ;

  _proto.emit = function emit(eventName) {
    for (var _len = arguments.length, info = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      info[_key - 1] = arguments[_key];
    }

    var listeners = this._listeners[eventName];
    listeners.map(function (listener) {
      return listener.apply(void 0, info);
    });
  }
  /**
   * Handles the API request.
   *
   * @param {*} method
   * @param {*} pseudoUrl
   * @param {*} args
   * @returns
   */
  ;

  _proto.request = function request(input) {
    return new this.Request(this, input);
  }
  /**
   * Creates requests handler.
   *
   * @param list
   */
  ;

  _proto.requests = function requests(list) {
    return new this.Requests(this, list);
  };

  return Apiator;
}();
/**
 * Register convenience request methods.
 */

['get', 'put', 'post', 'delete'].map(function (method) {
  Apiator.prototype[method] = function (url, moreInput) {
    return this.request(_extends({
      method: method,
      url: url
    }, moreInput));
  };
});

/**
 * +----------------------------------------------------------------------+
 * |                                                                      |
 * |  A p i a t o r                                                       |
 * |  -------------                                                       |
 * |  The awaited response to the request for a shiny API service.        |
 * |                                                                      |
 * +----------------------------------------------------------------------+
 *
 * @author fegodev
 * @version pre-alpha
 */

/**
 * Contains core features.
 */

var CoreFeatures = [BasicContextFeature, BasicResultFeature, BaseUrlFeature, ParamsFeature, QueryFeature, BodyFeature, OptsFeature, HeadersFeature, PayloadFeature, ContentTypeFeature, DupletFeature, DebugFeature];
/**
 * Contains Fetch API features.
 */

var FetchApiFeatures = /*#__PURE__*/[].concat(CoreFeatures, [FetchApiFeature, FetchApiAbortFeature, FetchApiFormatFeature]);
/**
 * Creates an instance with provided features and default args.
 *
 * @param features
 * @param args
 * @returns Apiator instance
 */

function createInstanceWith(features, args) {
  return new Apiator(features, args);
}
/**
 * Creates an instance with default features and args.
 *
 * @param args
 * @returns Apiator instance
 */

function createInstance(args) {
  return createInstanceWith(FetchApiFeatures, args);
}

export { AbortException, BaseUrlFeature, BasicContextFeature, BasicResultFeature, BodyFeature, ContentTypeFeature, CoreFeatures, DebugFeature, DupletFeature, Exception, FetchApiAbortFeature, FetchApiFeature, FetchApiFeatures, FetchApiFormatFeature, HeadersFeature, HttpException, NetworkException, OptsFeature, ParamsFeature, PayloadFeature, QueryFeature, Request, Requests, ScriptException, createInstance, createInstanceWith };
//# sourceMappingURL=apiator.esm.js.map
